import React, { useCallback, useState } from "react";
import { Button, Heading, Modal, Text, ModalVariant } from "base-ui";
import Highlighter from "./Highlight";
import { PageWrapper } from "./PageWrapper";
import { Modal as ModalExample } from "../examples/Modal";
import { IconCog } from '@paro.io/base-icons'

const Modals = () => {
  const [modalStates, setStateForVariant] = useState<Record<ModalVariant, boolean>>({
    [ModalVariant.passive]: false,
    [ModalVariant.transactional]: false,
    [ModalVariant.acknowledgement]: false,
  })

  const handleClose = useCallback((variant: ModalVariant) => {
    setStateForVariant({
      ...modalStates,
      [variant]: false,
    })
  }, [modalStates])

  const handleModalOpen = useCallback((variant: ModalVariant) => {
    setStateForVariant({
      ...modalStates,
      [variant]: true,
    })
  }, [modalStates])

  const onContinue = useCallback((variant) => {
    console.log('Clicked Continue')
    handleClose(variant)
  }, [modalStates])

  return (
    <PageWrapper title='Modal' isResponsive={true}>
      <Text size='md'>
        The modal or dialog element represents a part of an application that a user interacts with to perform a task, for example a dialog box, inspector, or window. The task to be performed is often contextual to the main page and focused on one activity only.
      </Text>

      <Heading size='h3'>Passive Modal</Heading>
      <div className='bg-gray-50 p-4 my-4 rounded-md text-center'>
        <Button
          color='primary'
          label='Open Passive Modal'
          onClick={() => handleModalOpen(ModalVariant.passive)}
        />
        <Modal 
          open={modalStates.passive}
          onClose={() => handleClose(ModalVariant.passive)}
          label="Passive Modal Title"
        >
          Text in a modal
        </Modal>
      </div>

      <Heading size='h3'>Acknowledgement</Heading>
      <div className='bg-gray-50 p-4 my-4 rounded-md text-center'>
        <Button
          color='primary'
          label='Open Acknowledgement Modal'
          onClick={() => handleModalOpen(ModalVariant.acknowledgement)}
        />
        <Modal
          open={modalStates.acknowledgement}
          variant={ModalVariant.acknowledgement}
          color="primary"
          onPrimaryButtonClickHandler={() => onContinue(ModalVariant.acknowledgement)}
          onClose={() => handleClose(ModalVariant.acknowledgement)}
          label="Acknowledgement Modal"
        >
          Text in a modal
        </Modal>
      </div>

      <Heading size='h3'>Transaction</Heading>
      <div className='bg-gray-50 p-4 my-4 rounded-md text-center'>
        <Button
          color="primary"
          label="Open Transactional Modal"
          onClick={() => handleModalOpen(ModalVariant.transactional)}
          />
        <Modal
          open={modalStates.transactional}
          onClose={() => handleClose(ModalVariant.transactional)}
          onPrimaryButtonClickHandler={() => onContinue(ModalVariant.transactional)}
          iconCustom={<IconCog />}
          color="primary"
          label="Transactional Modal"
          variant={ModalVariant.transactional}
        >
          Text in a modal
        </Modal>
        
      </div>


      <Heading size='h3'>Usage</Heading>
      <div className='py-4'>
        <Highlighter code={ModalExample} language='jsx' />
      </div>
    </PageWrapper>
  )
}

export default Modals
